module.exports = flarum.core.compat['extensions/afrux-forum-widgets-core/common/extend/Widgets'];